// Tema visual «Fanzine»: claro (verde/papel) ↔ oscuro (rosa/negro).
// Por defecto sigue prefers-color-scheme del sistema; el botón ☀/☾ persiste
// un override manual en <html data-mode="…"> + localStorage.

const STORAGE_KEY = 'qz-fanzine-mode';
const VALID = ['claro', 'oscuro'];
const THEME_COLOR = { claro: '#f1e7d2', oscuro: '#14110f' };

function storedOverride() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return VALID.includes(v) ? v : null;
  } catch {
    return null;
  }
}

function systemMode() {
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'claro' : 'oscuro';
}

// Modo efectivo que se está pintando: override manual si existe, si no el del SO.
export function getMode() {
  return storedOverride() ?? systemMode();
}

function paintMeta(mode) {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', THEME_COLOR[mode] || THEME_COLOR.oscuro);
}

// Fija un override manual y reskina al instante.
export function setMode(mode) {
  if (!VALID.includes(mode)) return;
  try { localStorage.setItem(STORAGE_KEY, mode); } catch {}
  document.documentElement.dataset.mode = mode;
  paintMeta(mode);
}

// Estado inicial: si hay override lo fija en el <html>; si no, no toca
// data-mode (deja mandar a la media query) y solo sincroniza meta.
export function initMode() {
  const override = storedOverride();
  if (override) document.documentElement.dataset.mode = override;
  paintMeta(getMode());
}

// Reacciona a cambios del SO solo cuando NO hay override manual.
export function onSystemChange(cb) {
  const mq = window.matchMedia?.('(prefers-color-scheme: light)');
  mq?.addEventListener?.('change', () => {
    if (!storedOverride()) { paintMeta(getMode()); cb?.(); }
  });
}
